import { render } from "./AddMinnen.vue?vue&type=template&id=580a2566&scoped=true"
import script from "./AddMinnen.vue?vue&type=script&lang=js"
export * from "./AddMinnen.vue?vue&type=script&lang=js"

import "./AddMinnen.vue?vue&type=style&index=0&id=580a2566&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580a2566"]])

export default __exports__